import { render, staticRenderFns } from "./AddOrderDialog.vue?vue&type=template&id=3831ae92&"
import script from "./AddOrderDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports